import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=82cdba12&scoped=true&lang=pug&"
import script from "./Client.vue?vue&type=script&lang=ts&"
export * from "./Client.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cdba12",
  null
  
)

export default component.exports